import { ScreenRecorderRecording } from "./ScreenRecorderRecording";
import { ScreenRecorderResult } from "./ScreenRecorderResult";
import { ScreenRecorderException } from "./ScreenRecorderException";
import {
  useScreenRecorder,
} from "./useScreenRecorder";
import { useEffect } from "react";
import { ReactMediaRecorderHookProps } from "react-media-recorder";

type ScreenRecorderType = {
  screenRecorderOptions: ReactMediaRecorderHookProps | null;
  startScreenRecording: React.MutableRefObject<(() => void) | null>;
  stopScreenRecording: React.MutableRefObject<(() => void) | null>;
  onFinish: () => void;
};

export function ScreenRecorder({
  screenRecorderOptions,
  startScreenRecording,
  stopScreenRecording,
  onFinish,
}: ScreenRecorderType) {
  const hookProps = useScreenRecorder(
    screenRecorderOptions as ReactMediaRecorderHookProps
  );
  useEffect(() => {
    if (
      hookProps.startRecording &&
      hookProps.stopRecording &&
      !startScreenRecording.current
    ) {
      startScreenRecording.current = hookProps.startRecording;
      stopScreenRecording.current = hookProps.stopRecording;
    }
  }, [hookProps, startScreenRecording, stopScreenRecording]);

  if (
    hookProps &&
    startScreenRecording.current &&
    stopScreenRecording.current
  ) {
    return (
      <>
        {hookProps.status === "recording" && (
          <ScreenRecorderRecording
            stop={stopScreenRecording.current}
            durationInMs={hookProps.durationInMs ?? 0}
          />
        )}
        {hookProps.status === "stopped" && (
          <ScreenRecorderResult hookProps={hookProps} onFinish={onFinish} />
        )}
        {hookProps.error && (
          <ScreenRecorderException
            error={hookProps.error}
            onFinish={onFinish}
          />
        )}
      </>
    );
  }
  return <></>;
}
